import {$, w} from './constants';

const cookies = () =>{

    if(localStorage.getItem('galanga_cookie')){
        $('#cookies-galanga').addClass('hide-cookies');
    }else{
        $('#cookies-galanga').delay(1500).fadeIn(500);
        $('.button-close--cookies').click(() => {
            localStorage.setItem('galanga_cookie', 'true');
            $('#cookies-galanga').addClass('hide-cookies');
            console.log('Acepto cookies')
        })
    }
   
}

const toScroll = (id_element) => {
    $('html, body').animate(
        {
          scrollTop: $(id_element).offset().top,
        },
        1200,
        'swing'
    )
}

function clickHandler(){
    console.log('window resize --handler')
    if( !($(w).width() == 1024 && $(w).height() >= 1024) && ($(w).width() > 959 )){
        $('#portada').click(() => {
            $('.about').slideUp(1000);
            $('#galeria').show(); 
            cookies();
        });
        $('.return-home').click(() => {
            $('.about').slideDown(1000);
            $('#galeria').slideUp(1000);
        })
    }
    else if(($(w).width()  == 1024 && $(w).height() >= 1024) || ($(w).width() <= 959)){
        $('.main-container').addClass('hide');
        $('.arrow').click(() => {
            toScroll('#galeria');
            cookies();
        });

        $('.button-close--banner').click(() => {
            $('#modal-popup').toggleClass('show-popup');
        })
    }
    else{
        $('.main-container').removeClass('hide');
        $('.arrow').click(() => {
            toScroll('#galeria');
            cookies();
        });

        $('.button-close--banner').click(() => {
            $('#modal-popup').toggleClass('show-popup');
        })
    }
}
function slider() {
    console.log('window resize --slider')
   //Condiciones para mostrar en iPad Pro el scroll
    if (($(window).width() == 1024 && $(window).height() >= 1024) || ($(window).width() < 959 )){
      console.log('Scroll iPad Pro');
    }else{
      $('.slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<div class='slick-prev slick-arrow'>",
        nextArrow: "<div class='slick-next slick-arrow'>",
        responsive: [
            {
              breakpoint: 960,
              settings: 'unslick'
            }
        ]
      });
      $(".slick-prev").hide();
      $(".slick-arrow").on("click", () => {
          let isFirst = $(".slick-slide").first().hasClass("slick-current");
          let isLast = $(".slick-slide").last().hasClass("slick-current");
          isFirst ?($('.slick-prev').hide(), $('.slick-prev').addClass('not-arrow')) : ($(".slick-prev").show(), $('.slick-prev').removeClass('not-arrow'));
          isLast ? ($('.slick-next').hide(), $('.slick-prev').addClass('is-last')) : ($('.slick-prev').removeClass('is-last'), $('.slick-next').show());
      });
    }
  }
function resizeContent (){
    console.log('resize--gral')
    clickHandler();
    slider();
}
$(document).ready(function() {
    clickHandler();
    slider();

    $('.gallery__slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      speed: 500,
      pauseOnFocus: false,
      pauseOnHover: false
    });
});


window.onresize = resizeContent;


// WEBPACK FOOTER //
// ./es6/click-handler.js